import { memo, useMemo } from 'react';

import * as THREE from 'three';

import { VISUALIZER_KEYS } from '../constants';

export type SwingPlaneType = 'Backswing plane' | 'Downswing plane';

export type ShaftPosition = { start: THREE.Vector3; end: THREE.Vector3 };

export type PlanePosition = { normal: THREE.Vector3; center: THREE.Vector3 };

type SwingPlaneProps = {
    type: string;
    opacity?: number;
} & PlanePosition;

const planeColorMap: Record<string, number> = {
    [VISUALIZER_KEYS.SWING_PLANE]: 0x61ff00,
    [VISUALIZER_KEYS.SETUP_PLANE]: 0x3b82f6,
    [VISUALIZER_KEYS.IMPACT_PLANE]: 0xf97316,
    [VISUALIZER_KEYS.TRAIL_ELBOW_PLANE]: 0xa855f7,
    [VISUALIZER_KEYS.TRAIL_SHOULDER_PLANE]: 0xec4899,
};

const planeSize = [2.5, 0.01, 1.5] as [number, number, number];

export const SwingPlane = memo(({ center, normal, type, opacity = 1 }: SwingPlaneProps) => {
    const finalQuaternion = useMemo(() => {
        const initialRotation = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), -Math.PI / 2);
        const targetQuaternion = new THREE.Quaternion().setFromUnitVectors(new THREE.Vector3(0, 0, 1), normal);
        return new THREE.Quaternion().multiplyQuaternions(targetQuaternion, initialRotation);
    }, [normal]);

    return (
        <mesh position={center} quaternion={finalQuaternion}>
            <boxGeometry args={planeSize} />
            <meshStandardMaterial
                color={planeColorMap[type]}
                transparent
                opacity={(1 / 3) * opacity}
                side={THREE.DoubleSide}
                depthWrite={true}
                depthTest={true}
            />
        </mesh>
    );
});
